import React from 'react';
import { STATUS_SOLICITACAO_LABEL } from '../services/solicitacaoService';

const TOM: Record<string, string> = {
  ABERTA: 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-700/50 dark:bg-amber-500/10 dark:text-amber-200',
  EM_ANALISE: 'border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-700/50 dark:bg-sky-500/10 dark:text-sky-200',
  ATENDIDA: 'border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-700/50 dark:bg-emerald-500/10 dark:text-emerald-200',
  RECUSADA: 'border-red-300 bg-red-50 text-red-900 dark:border-red-700/50 dark:bg-red-500/10 dark:text-red-200',
};

/** Selo do status do pedido, em linguagem simples e com cor. */
const StatusPedido: React.FC<{ status: string; grande?: boolean }> = ({ status, grande = false }) => (
  <span
    className={`inline-flex items-center rounded-full border font-semibold ${
      grande ? 'px-4 py-1.5 text-base' : 'px-3 py-1 text-sm'
    } ${TOM[status] ?? 'border-slate-300 bg-slate-50 text-slate-800'}`}
  >
    {STATUS_SOLICITACAO_LABEL[status] ?? status}
  </span>
);

export default StatusPedido;
